import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
  isSessionVaild = true;

  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { this.isSessionVaild = true; }

  // This function loads/displays all Miscellaneous from database
  // This gives call to Get method from MiscController
  getMiscellaneous(group) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Misc/GetByGroupName?CommonGroupName=' + group,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }




  // This function loads/displays all list of group from database
  // This gives call to Get method from MiscController
  getGroupList() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Misc/GetGroupList', { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  /* Below is CRUD for Miscellaneous */

  // This function gets Miscellaneous on the basis of id  from database
  // This gives call to Get method from MiscController
  // Parameter: MiscID
  getMiscById(MiscID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Misc/' + MiscID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function Saves/updates Miscellaneous from database
  // This gives call to post method from MiscController
  // Parameter: Miscellaneous object
  saveMiscellaneous(Miscellaneous) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Misc', Miscellaneous, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function deactivates Miscellaneous from database
  // This gives call to delete method from MiscController
  // Parameter: MiscId
  DeactivateMiscellaneous(MiscID) {
    const customHeaders = this.globals.GetCustomHeadersForDelete();
    return this.http.delete<any>(environment.apiUrl + 'Misc/' + MiscID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
}
